var React = require('react');

function PolygonGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M233.501 154.673L0.929222 249.947L34.7053 0.89696L233.501 154.673Z","fill":"#DDDDDD"}));
}

PolygonGrey.defaultProps = {"width":"251","height":"280","viewBox":"0 0 251 280","fill":"none"};

module.exports = PolygonGrey;

PolygonGrey.default = PolygonGrey;
